var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 62,
    viewBox: "0 0 48 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4785 5.6126L25.9711 0L21.8536 4.10849L5.85551 20.0731L1.25387 24.6632L11.6331 27.4382L16.2332 22.8466L28.7507 10.3566L27.4769 5.61108L27.4785 5.6126ZM19.6085 55.6339L21.1159 61.2465L25.2334 57.138L41.233 41.1733L45.8331 36.5833L35.4538 33.8082L30.8537 38.3998L18.3363 50.8899L19.61 55.6354L19.6085 55.6339ZM40.0539 29.2166L47.0854 31.0972L45.2008 24.081L44.3043 20.7406L40.9321 19.8384L30.5528 17.0634L22.9547 24.6449L22.1529 25.4449L18.3531 29.2365L13.7514 33.8265L7.0315 32.0298L0 30.1493L1.88463 37.1669L2.78113 40.5074L6.15333 41.4096L16.5326 44.1846L24.1307 36.6031L24.9325 35.803L28.7323 32.0115L33.3324 27.4215L40.0524 29.2182L40.0539 29.2166Z",
    fill: "url(#paint0_linear_10_493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_493",
    x1: 10.0173,
    y1: 4.46662,
    x2: 38.362,
    y2: 53.2784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98FF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47DAFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small_logo.fc3b209f2f186809ff05c397ad2a19c8.svg";
export { ForwardRef as ReactComponent };